import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query listProduct(
        $ids: [String]
        $brand_ids: [String]
        $unit_ids: [String]
        $category_ids: [String]
        $creator_ids: [String]
        $barcodes: [String]
        $nulls: [String]
        $title: String
        $introtext: String
        $fulltext: String
        $is_active: Int
        $for_admin: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        product(
          ids: $ids
          brand_ids: $brand_ids
          unit_ids: $unit_ids
          category_ids: $category_ids
          creator_ids: $creator_ids
          barcodes: $barcodes
          nulls: $nulls
          title: $title
          introtext: $introtext
          fulltext: $fulltext
          is_active: $is_active
          for_admin: $for_admin
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            barcode
            brand {
              id
              title
            }
            title
            introtext
            media {
              full_url
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteProduct',
    serviceName: 'admin',
    query: gql`
      mutation deleteProduct($ids: [String]!) {
        deleteProduct(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query product($ids: [String]) {
        product(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query product($ids: [String]) {
        product(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
